export default "__VITE_ASSET__e5aaa2dc__"